import { Component, inject, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe } from '@angular/common';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Collaborateur } from '../../../shared/model';
import { MatDialog } from '@angular/material/dialog';
import { DatabaseConnection } from '../../../shared/services/database-connection';
import { SuiviService } from '../../service/suivi-service';
import { RenvoiCompagnieModal } from '../modal/renvoi-compagnie-modal';

@Component({
  selector: 'app-renvoi-compagnie',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSpinner
  ],
  templateUrl: './renvoi-compagnie.html',
  styleUrl: './renvoi-compagnie.css',
})
export class RenvoiCompagnie {

   displayedColumns: string[] = ['compagnie', 'collaborateur', 'total'];
  dataSource : MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  readonly dialog = inject(MatDialog);

  loading = false

  constructor(
    private suiviService : SuiviService
  ){}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loading = true
    this.suiviService.renvoiCompagnie().subscribe({
      next : (res) => {
          this.dataSource.data = res
          this.loading = false
      },
      error : (err) =>{
        this.loading = false
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  

  openDetails(renvoi : RenvoiCompagnie){

    const dialogRef = this.dialog.open(RenvoiCompagnieModal, {
      width : '1200px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : renvoi
    });

    dialogRef.afterClosed().subscribe((result : any) => {

    });
  }
}
